export const CLINIC = {
    name: 'Doctor Mohsin Kidney Clinic',
    urduName: 'محسن کڈنی کلینک',
    doctorName: 'Dr. Muhammad Mohsin Riaz',
    qualifications: 'MBBS, FCPS (Nephrology), ISN Fellow',
    title: 'Assistant Professor of Nephrology',
    specialty: 'Consultant Interventional Nephrologist &',
    specialtyContinued: 'Transplant Physician',
    hospital: 'Omar Hospital & Cardiac Centre, Johar Town, Lahore',
    phone: '0323-4566640',
    phoneNote: 'For Appointment & WhatsApp',
    appointmentNote: 'Consultation with appointment only.',
    consultationLabel: 'For Consultation:',
    consultationHours: 'Monday to Friday (5:00 PM to 8:00 PM)',
    leftLogoCaption: 'HOME PERITONEAL DIALYSIS',
};

export const MEDICINE_TYPES = [
    { value: 'Tablet', label: 'Tablet' },
    { value: 'Capsule', label: 'Capsule' },
    { value: 'Syrup', label: 'Syrup' },
    { value: 'Injection', label: 'Injection' },
    { value: 'Drip', label: 'Drip' },
    { value: 'Drops', label: 'Drops' },
    { value: 'Cream', label: 'Cream' },
    { value: 'Sachet', label: 'Sachet' },
    { value: 'Inhaler', label: 'Inhaler' },
];

export const FREQUENCY_OPTIONS = [
    { value: '1', label: 'OD  1-0-0' },
    { value: '2', label: 'BD  1-0-1' },
    { value: '3', label: 'TDS  1-1-1' },
    { value: '4', label: 'QID  1-1-1-1' },
];

export const INTAKE_OPTIONS = [
    { value: '1', label: '1' },
    { value: '1/2', label: '1/2' },
    { value: '1/4', label: '1/4' },
    { value: '2', label: '2' },
];

export const INSTRUCTION_OPTIONS = [
    { value: 'After meals', label: 'After meals' },
    { value: 'Before meals', label: 'Before meals' },
    { value: 'With water', label: 'With water' },
    { value: 'At bedtime', label: 'At bedtime' },
    { value: 'Empty stomach', label: 'Empty stomach' },
    { value: 'As needed', label: 'As needed' },
];

export const emptyMedicine = () => ({
    id: `${Date.now()}-${Math.random().toString(16).slice(2)}`,
    type: 'Tablet',
    name: '',
    frequencyDaily: '1',
    frequencyIntake: '1',
    frequencyDays: '7',
    inTakeInstructions: 'After meals',
});

export const dosePattern = (times) => {
    const value = Number(times);
    if (value === 100 || value === 1) return '1-0-0';
    if (value === 101 || value === 2) return '1-0-1';
    if (value === 111 || value === 3) return '1-1-1';
    if (value === 1111 || value === 4) return '1-1-1-1';
    return String(times || '');
};

export const formatRxDate = (value) => {
    if (!value) return '';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    return date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
    });
};

export const formatPadDate = (value) => {
    if (!value) return '';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    return `${date.getDate()}/${date.getMonth() + 1}/${String(date.getFullYear()).slice(-2)}`;
};

export const medicineTypeShort = (type) => {
    const map = {
        Tablet: 'Tab',
        Capsule: 'Cap',
        Syrup: 'Syp',
        Injection: 'Inj',
        Drip: 'Drip',
        Drops: 'Drops',
        Cream: 'Cream',
        Sachet: 'Sach',
        Inhaler: 'Inh',
    };
    return map[type] || type || 'Tab';
};

export const dosePatternSpaced = (times) => dosePattern(times).replace(/-/g, ' - ');

export const formatVisitDateTime = (value) => {
    if (!value) return '—';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '—';
    return date.toLocaleString('en-GB', {
        weekday: 'short',
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
    });
};

export const patientAgeSex = (age, sex) => {
    const years = age ? `${age}yrs` : '';
    const initial = sex ? String(sex).trim().charAt(0).toUpperCase() : '';
    return [years, initial].filter(Boolean).join('/');
};
